import { challengeDetailsIds } from "@artists/challenges-testkit"
import { Link, Skeleton, Typography } from "@mui/material"
import { Trans, useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router-dom"

import type { Challenge } from "../../../../api/hooks/vote"
import { format, Root } from "../../../../utils"
import { Time } from "../../../@shared"

interface Props {
	challenge: Maybe<Challenge>
}

export const Overlay = ({ challenge }: Props) => {
	const { t } = useTranslation("vote")

	if (!challenge) {
		return (
			<>
				<Skeleton
					width='100%'
					sx={{ typography: { sm: "h4", xs: "h5" }, mb: 2.5 }}
				/>
				<Skeleton
					width='40%'
					sx={{ typography: { sm: "h4", xs: "h5" }, mb: 2.5 }}
				/>
			</>
		)
	}

	const { name, votingClosesAt, slug, status } = challenge

	return (
		<>
			<Typography
				textAlign='center'
				variant='h4Serif'
				component='h1'
				fontSize='2.25em'
				data-testid={challengeDetailsIds.title}
				mb={2.5}
			>
				<Trans
					ns='vote'
					i18nKey='title'
					values={{ challengeName: name }}
				>
					<em />
				</Trans>
			</Typography>
			<Typography
				variant='subtitle2'
				component='p'
				fontWeight='bold'
				color='warning.dark'
				mb={1}
			>
				<Trans
					ns='vote'
					i18nKey='votingCloses'
					values={{
						date: format(votingClosesAt, "eee, MMM d"),
						time: format(votingClosesAt, "ha z"),
					}}
				>
					<Time children={undefined} />
				</Trans>
			</Typography>
			<Link
				component={RouterLink}
				to={Root.Challenge.buildPath({ slug })}
				state={Root.Challenge.buildState({
					status: status.current.name,
				})}
				color='warning.dark'
				variant='subtitle2'
				fontWeight='bold'
			>
				{t("home")}
			</Link>
		</>
	)
}
